export default __webpack_public_path__ + "static/media/preloader.2a75fc9d.gif";